"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePassword = exports.passwordUIPrompts = exports.passwordRegex = exports.passwordErrorMsgs = void 0;
var passwordRegex = exports.passwordRegex = {
  all: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/g,
  whiteSpaces: /[\s]/,
  minLength: 8,
  digitRegex: /\d/,
  symbolRegex: /["!#$%&’()*+,-./:;<=>?@[\]^_`{|}~]/,
  characterRegex: /([\S]*[A-Z]+[\S]*[a-z]+[\S]*)|([\S]*[a-z]+[\S]*[A-Z]+[\S]*)/
};
// (?=.*["!#$%&'’()*+,-./:;<=>?@[\]^_`{|}~])
var passwordErrorMsgs = exports.passwordErrorMsgs = {
  invalidPassword: 'Please enter valid password',
  all: 'Password Error: Should have minimum -> 8 char, 1 UpperCase, 1 LowerCase and 1 Digit (0-9)',
  currentPassword: 'Current Password: cannot be empty',
  newPasswordCannotBeSameAsOld: "New password shouldn't be same as old.",
  whiteSpaces: 'Password: Cannot be empty and white space is not allowed',
  minLength: 'Password: Minimum length - 8 characters',
  digitRegex: 'Password: At least 1 number',
  symbolRegex: 'Password: At least 1 special character ("!#$%&’()*+,-./:;<=>?@[]^_`{|}~)',
  characterRegex: 'Password: At least 1 capital letter & 1 lowercase character',
  confirmPasswordFailed: 'Confirm Password does not match Password'
};
var passwordUIPrompts = exports.passwordUIPrompts = {
  minLength: 'Use at least 8 characters',
  digitRegex: 'Use at least one number (0-9)',
  symbolRegex: 'Use at least one special character ("!#$%&’()*+,-./:;<=>?@[]^_`{|}~)',
  characterRegex: 'Use at least one uppercase and one lowercase letter',
  confirmPasswordFailed: 'Passwords must match',
  passwordNotCloseToUsername: 'Your password may not contain your email address'
};
// validate the confirm password and show the error messages if any
var validatePassword = exports.validatePassword = function validatePassword(passwordText) {
  var passwordValidation = {
    passwordLength: false,
    passwordDigit: false,
    passwordCharSmallCaps: false
  };
  if (passwordText.length >= passwordRegex.minLength) {
    passwordValidation.passwordLength = true;
  } else {
    passwordValidation.passwordLength = false;
  }

  //digitMatcher
  var digitRegex = passwordRegex.digitRegex;
  if (String(passwordText).match(digitRegex)) {
    passwordValidation.passwordDigit = true;
  } else {
    passwordValidation.passwordDigit = false;
  }

  //symbolMatcher
  /*  const symbolRegex = passwordRegex.symbolRegex;
  if (String(passwordText).match(symbolRegex)) {
    passwordValidation.passwordSymbol = true;
  } else {
    passwordValidation.passwordSymbol = false;
  }*/

  //atleast one capital and one small latter matcher
  var characterRegex = passwordRegex.characterRegex;
  if (String(passwordText).match(characterRegex)) {
    passwordValidation.passwordCharSmallCaps = true;
  } else {
    passwordValidation.passwordCharSmallCaps = false;
  }
  return passwordValidation;
};